import { OrderFlowAuthService } from '../auth/order-flow-auth.service';
import { ROLE_GROUPS } from '../shared/authz/role-groups';

export function canViewOrders(authService: OrderFlowAuthService): boolean {
  return authService.hasOneOfRoles(ROLE_GROUPS.viewOrders);
}

/**
 * A partial-executions reader with no order access at all — the one role combination that lands
 * somewhere other than /orders after login. Routes and templates should use `roleGuard` /
 * `of-role-gate` with a group instead of a helper like this.
 */
export function canViewOnlyPartialExecutions(authService: OrderFlowAuthService): boolean {
  return (
    !authService.hasOneOfRoles(ROLE_GROUPS.orderReadWrite) &&
    authService.hasOneOfRoles(ROLE_GROUPS.partialExecutionsReaderOnly)
  );
}
